<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">sell</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Modificar parámetros para tasa de venta USDT</h1>
  </div>

  <!-- Candado de edición (solo producción). Ver AdminEditPermissionsService -->
  <app-solo-lectura-banner *ngIf="!puedeEditar"
    detalle="La edición de los parámetros de tasa de venta USDT está reservada al operador autorizado.">
  </app-solo-lectura-banner>

  <!-- Card Formulario -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6 max-w-2xl mx-auto">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">tune</mat-icon>
        Parámetros de Venta
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="ratesForm" class="space-y-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Valor Solvencia (ValueSL)</mat-label>
            <span matTextPrefix>CLP &nbsp; &nbsp; </span>
            <input matInput formControlName="valueSL" appOnlynumber matInputCommified type="text" placeholder="Value SL">
          </mat-form-field>
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Valor liquidez (ValueLQ)</mat-label>
            <span matTextPrefix>USDT &nbsp;</span>
            <input matInput formControlName="valueLQ" appOnlynumber matInputCommified type="text" placeholder="Value LQ">
          </mat-form-field>
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Descuento 1</mat-label>
            <span matTextPrefix>USDT &nbsp;</span>
            <input matInput formControlName="discount1" appOnlynumber [allowNegative]="true" type="text" placeholder="Discount 1">
          </mat-form-field>
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Descuento 2</mat-label>
            <span matTextPrefix>USDT &nbsp;</span>
            <input matInput formControlName="discount2" appOnlynumber [allowNegative]="true" type="text" placeholder="Discount 2">
          </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
          <button type="button" [disabled]="!puedeEditar"
            [style.opacity]="puedeEditar ? '1' : '0.5'"
            [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="showConfirm()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
            Actualizar
          </button>
          <button type="button" [disabled]="!puedeEditar"
            [style.opacity]="puedeEditar ? '1' : '0.5'"
            [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="reset()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">restart_alt</mat-icon>
            Restablecer
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Componente Tasa Update -->
  <div class="flex flex-col w-full justify-center items-center mb-6">
    <app-rate-update-type [showOnlyUSDTSale]="true" class="w-full max-w-2xl"></app-rate-update-type>
  </div>

  <!-- Card Historial -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;"
      class="flex items-center justify-between">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">history</mat-icon>
        Historial de la tasa de Venta
      </h2>
      <button type="button" (click)="reload()"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 16px; background: #1e3a5f; color: white; border: none; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#2563eb'" onmouseout="this.style.background='#1e3a5f'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">refresh</mat-icon>
        Refrescar
      </button>
    </div>

    <div class="p-4">
      <mat-paginator
        #paginator
        (page)="onPageChange($event)"
        [length]="totalItems"
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [pageIndex]="currentPage - 1">
      </mat-paginator>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto" *ngIf="dataSource">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.createdAt | date:'dd/MM/yyyy' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="hora">
          <th mat-header-cell *matHeaderCellDef>Hora</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.createdAt | date:'hh:mm a':'America/Santiago' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef>Tasa de Negociación</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" style="color: #1e5a3f;">{{ row.tasaUsdtClp ? (row.tasaUsdtClp | number:'1.2-2') : '' }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-2 px-4 pb-4" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.filteredData"
        class="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
        <div class="flex items-center gap-3">
          <span class="text-xs text-gray-500">{{ row.createdAt | date:'dd/MM/yyyy' }}</span>
          <span class="text-xs text-gray-400 font-mono">{{ row.createdAt | date:'hh:mm a':'America/Santiago' }}</span>
        </div>
        <span class="text-sm font-bold" style="color: #1e5a3f;">{{ row.tasaUsdtClp ? (row.tasaUsdtClp | number:'1.2-2') : '' }}</span>
      </div>
    </div>
  </div>
</div>
